// Stable per-device UUID. Generated on first use and stored in
// localStorage so the same value rides every auth call from this
// browser profile. The auth backend uses it to identify a session and
// enforce the per-user MaxSessions cap (a hard cap: past the limit the
// new sign-in is rejected with DEVICE_LIMIT_EXCEEDED, never auto-evict;
// the user frees a slot by revoking from an already-signed-in device).

const DEVICE_ID_KEY = 'app.device.id';
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function getDeviceId(): string {
  try {
    const existing = localStorage.getItem(DEVICE_ID_KEY);
    if (existing && UUID_RE.test(existing)) return existing;
    const fresh = generateUUID();
    localStorage.setItem(DEVICE_ID_KEY, fresh);
    return fresh;
  } catch {
    // Private mode / storage disabled: fall back to a session-scoped
    // UUID. Auth flows still work; the session just won't be recognized
    // as the same device on the next page load.
    return generateUUID();
  }
}

function generateUUID(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // RFC 4122 v4 fallback for older browsers.
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0'));
  return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10, 16).join('')}`;
}
